import { UPDATE_HEADER_INFO, UPDATE_FOOTER_INFO } from "../actions";

const INITIAL_STATE = {
    headerText: "SASP",
    iconOne: "",
    iconTwo: "",
    footerOne: "rankings",
    footerTwo: "myDecks",
    footerThree: "inbox",
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_HEADER_INFO:
            return {
                ...state,
                headerText: action.payload.headerText,
                iconOne: action.payload.iconOne,
                iconTwo: action.payload.iconTwo,
                backgroundcolor: action.payload.backgroundcolor
            };

        case UPDATE_FOOTER_INFO:
            return {
                ...state,
                footerOne: action.payload.footerOne,
                footerTwo: action.payload.footerTwo,
                footerThree: action.payload.footerThree,
            }
        
        default:
            return state;
    }
};
